import React from 'react'
import { Redirect } from 'react-router-dom'
import { Toggle } from 'libreact/lib/Toggle'
import styled from 'styled-components'
import Button from '../../Button'

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px;
`

export default ({ set, form: { resetForm } }) => (
  <Container>
    <Toggle>
      {({ on, toggle }) => (
        <>
          <Button type='neutral' onClick={() => { resetForm(); set(false); toggle() }}>
            Yes
          </Button>
          {on && <Redirect to='/monthly-costs' />}
        </>
      )}
    </Toggle>
    <Button onClick={() => set(false)}>
      No
    </Button>
  </Container>
)
